module.exports = __webpack_public_path__ + "static/media/berkley.2a9f0a67.webp";